import React, { useEffect, useRef, useState } from "react";
import ModalDefault from "../../modalDefault";
import { DataTable } from "mantine-datatable";
import { toast } from "react-hot-toast";
import {
  ApiDeleteComidaPeriodo,
  ApiGetAllComidasPeriodo,
} from "../../../api/comidasPeriodo";
import { ActionIcon, Group, MultiSelect } from "@mantine/core";

const BATCH_SIZE = 15;

const TablaComidasPeriodo = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [allComidasPeriodo, setAllComidasPeriodo] = useState([]);
  const [filteredComidasPeriodo, setFilteredComidasPeriodo] = useState([]);
  const [fetching, setfetching] = useState(true);
  const [selectedComidaPeriodo, setSelectedComidaPeriodo] = useState(null);

  // Estados para scroll infinito y filtros
  const [loadingMore, setLoadingMore] = useState(false);
  const [loadedRecords, setLoadedRecords] = useState(BATCH_SIZE);
  const [selectedPeriodos, setSelectedPeriodos] = useState([]);
  const [selectedComidas, setSelectedComidas] = useState([]);
  const [queryHoraAntes, setQueryHoraAntes] = useState("");
  const [queryMaximoPersonas, setQueryMaximoPersonas] = useState("");
  const scrollViewportRef = useRef(null);

  //ordenamiento
  const [isInit, setIsInit] = useState(false);
  const [sortStatus, setSortStatus] = useState({
    columnAccessor: "",
    direction: "asc",
  });

  const columns = [
    {
      accessor: "pre_periodos.nombre",
      title: "Periodo",
      textAlignment: "center",
      filter: (
        <MultiSelect
          data={
            props.listadoPeriodos.map((periodo) => ({
              value: periodo.pre_periodo_id,
              label: periodo.nombre,
            })) || []
          }
          placeholder="Filtrar por periodo..."
          value={selectedPeriodos}
          onChange={(values) => {
            setSelectedPeriodos(values);
          }}
        />
      ),
      filtering: selectedPeriodos.length > 0,
    },
    {
      accessor: "pre_comidas.nombre",
      title: "Comida",
      textAlignment: "center",
      filter: (
        <MultiSelect
          data={
            props.listadoComidas.map((comida) => ({
              value: comida.pre_comida_id,
              label: comida.nombre,
            })) || []
          }
          placeholder="Filtrar por comida..."
          value={selectedComidas}
          onChange={(values) => {
            setSelectedComidas(values);
          }}
        />
      ),
      filtering: selectedComidas.length > 0,
    },
    {
      accessor: "horas_antes",
      title: "Horas de anticipación",
      textAlignment: "center",
      sortable: true,
    },
    {
      accessor: "maximo_persona",
      title: "Máximo de solicitudes por persona",
      textAlignment: "center",
      sortable: true,
    },
    {
      accessor: "subsidio",
      title: "Subsidio",
      textAlignment: "center",
      sortable: true,
    },
    {
      accessor: "acciones",
      title: "Acciones",
      textAlignment: "center",
      render: (record) => opciones(record),
    },
  ];

  useEffect(() => {
    init();
  }, [props.updateList]);

  const init = async () => {
    setfetching(true);
    const { data } = await ApiGetAllComidasPeriodo();
    const filterComidasPeriodo = data.filter(
      (comida) => comida.estado !== false
    );
    setAllComidasPeriodo(filterComidasPeriodo);
    setFilteredComidasPeriodo(filterComidasPeriodo);
    setfetching(false);
    setIsInit(true);
  };

  //logica para manejar los filtros
  useEffect(() => {
    const queryMaximoPersonasLower = queryMaximoPersonas
      .toString()
      .toLowerCase();
    const queryHoraAntesLower = queryHoraAntes.toString().toLowerCase();

    const selectedPeriodosSet = new Set(selectedPeriodos);
    const isPeriodoSelected = (periodo) =>
      selectedPeriodos.length === 0 ||
      selectedPeriodosSet.has(periodo.pre_periodo_id);

    const selectedComidasSet = new Set(selectedComidas);
    const isComidaSelected = (comida) =>
      selectedComidas.length === 0 ||
      selectedComidasSet.has(comida.pre_comida_id);

    const filteredComidasPeriodo = allComidasPeriodo.filter((comidaPeriodo) => {
      return (
        comidaPeriodo.horas_antes
          .toString()
          .toLowerCase()
          .includes(queryHoraAntesLower) &&
        comidaPeriodo.maximo_persona
          .toString()
          .toLowerCase()
          .includes(queryMaximoPersonasLower) &&
        isPeriodoSelected(comidaPeriodo) &&
        isComidaSelected(comidaPeriodo)
      );
    });
    setFilteredComidasPeriodo(filteredComidasPeriodo);
  }, [
    allComidasPeriodo,
    selectedPeriodos,
    selectedComidas,
    queryHoraAntes,
    queryMaximoPersonas,
  ]);

  //logica para manejar el ordenamiento
  useEffect(() => {
    if (!isInit) return;
    if (sortStatus.columnAccessor === "horas_antes") {
      const sortedRecords = [...allComidasPeriodo].sort((a, b) => {
        const horaAntesA = Number(a.horas_antes);
        const horaAntesB = Number(b.horas_antes);
        return horaAntesA - horaAntesB;
      });

      if (sortStatus.direction === "desc") {
        setAllComidasPeriodo(sortedRecords.reverse());
      } else {
        setAllComidasPeriodo(sortedRecords);
      }
    }

    if (sortStatus.columnAccessor === "maximo_persona") {
      const sortedRecords = [...allComidasPeriodo].sort((a, b) => {
        const maximoPersonaA = Number(a.maximo_persona);
        const maximoPersonaB = Number(b.maximo_persona);
        return maximoPersonaA - maximoPersonaB;
      });

      if (sortStatus.direction === "desc") {
        setAllComidasPeriodo(sortedRecords.reverse());
      } else {
        setAllComidasPeriodo(sortedRecords);
      }
    }
  }, [sortStatus]);

  // Carga más datos cuando se llega al final del scroll
  const loadMoreData = () => {
    if (loadedRecords < filteredComidasPeriodo.length) {
      setLoadingMore(true);
      setTimeout(() => {
        setLoadedRecords(loadedRecords + BATCH_SIZE);
        setLoadingMore(false);
      }, 1000);
    }
  };

  const visibleComidasPeriodo = filteredComidasPeriodo.slice(
    0,
    Math.min(loadedRecords, filteredComidasPeriodo.length)
  );

  const editComidaPeriodo = (row) => {
    const {
      horas_antes,
      maximo_persona,
      pre_comida_periodo_id,
      pre_periodo_id,
      subsidio,
    } = row;
    props.setType("editar");
    props.setState({
      ...props.state,
      horas_antes,
      maximo_persona,
      pre_comida_periodo_id,
      pre_periodo_id,
      subsidio,
    });
  };

  const onShowModal = (e) => {
    setShowModal(true);
    setSelectedComidaPeriodo(e);
  };

  const onClosedModal = () => {
    setShowModal(false);
    setSelectedComidaPeriodo(null);
  };

  const onDelete = async () => {
    const { estado, pre_comida_periodo_id } = selectedComidaPeriodo;
    const { sms, mensaje } = await ApiDeleteComidaPeriodo({
      pre_comida_periodo_id,
      estado: !estado,
    });
    if (sms === "ok") {
      toast.success(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid green",
          padding: "16px",
          color: "white",
          background: "green",
          borderColor: "white",
        },
        iconTheme: {
          primary: "green",
          secondary: "white",
        },
      });
      setSelectedComidaPeriodo(null);
      props.updateListFn();
    } else {
      toast.error(mensaje, {
        position: "bottom-left",
        style: {
          border: "1px solid red",
          padding: "16px",
          color: "white",
          background: "red",
          borderColor: "white",
        },
        iconTheme: {
          primary: "red",
          secondary: "white",
        },
      });
    }
    onClosedModal();
  };

  const opciones = (row) => {
    return (
      <Group spacing={4} position="center" noWrap>
        <ActionIcon
          color="blue"
          onClick={() => {
            editComidaPeriodo(row);
          }}
        >
          <i className="fas fa-file-pen"></i>
        </ActionIcon>
        <ActionIcon
          color="red"
          onClick={() => {
            onShowModal(row);
          }}
        >
          <i className="fas fa-trash"></i>
        </ActionIcon>
        <ModalDefault
          bandera={"confirmacion"}
          modal={showModal}
          size={"sm"}
          icontitulo={<null />}
          titulo={`Confirmación`}
          closeAction={onClosedModal}
        >
          <div className="row py-4 justify-content-center text-align-center ">
            Realmente desea eliminar
          </div>
          <div className="d-flex justify-content-end flex-row align-self-start my-4">
            <button
              type=""
              onClick={onClosedModal}
              className="bg-btn-vet-danger sombra mx-1"
            >
              Cancelar
            </button>
            <button
              type=""
              onClick={onDelete}
              className="bg-btn-vet sombra mx-1"
            >
              <i className="fas fa-save"> Eliminar</i>
            </button>
          </div>
        </ModalDefault>
      </Group>
    );
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <DataTable
          borderRadius="md"
          className="bordecompleto bgfondo "
          highlightOnHover
          noRecordsText="No se encontraron datos"
          columns={columns}
          totalRecords={allComidasPeriodo.length}
          withColumnBorders
          records={visibleComidasPeriodo}
          fetching={fetching || loadingMore}
          onScrollToBottom={loadMoreData}
          scrollViewportRef={scrollViewportRef}
          style={{ maxHeight: "350px", overflowY: "auto" }}
          sortStatus={sortStatus}
          onSortStatusChange={setSortStatus}
        />
      </div>
    </div>
  );
};

export default TablaComidasPeriodo;
